/*
 * author kcz
 * date 2019-11-20
 */
import OrginRecordWord from "./index.vue";

OrginRecordWord.install = function(Vue) {
  console.info("OrginRecordWord",OrginRecordWord.name)
  Vue.component(OrginRecordWord.name, OrginRecordWord);

};

export default OrginRecordWord;
